import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import './AdminLogin.css';

export default function AdminLogin() {
  const [step, setStep] = useState('email'); // 'email' | 'otp'
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSendCode = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: { shouldCreateUser: false }, // only allow existing/allow-listed emails
    });

    setLoading(false);

    if (error) {
      setError(error.message);
      return;
    }
    setStep('otp');
  };

  const handleVerifyCode = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const { error } = await supabase.auth.verifyOtp({
      email,
      token: code,
      type: 'email',
    });

    setLoading(false);

    if (error) {
      setError('Invalid or expired code. Please try again.');
      return;
    }
    navigate('/2gslikegucciadmin');
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <h1 className="admin-login-title">2gs Like Gucci</h1>
        <p className="admin-login-sub">Admin Dashboard</p>

        {step === 'email' ? (
          <form onSubmit={handleSendCode} className="admin-login-form">
            <label className="admin-login-label">Email address</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="admin-login-input"
            />
            {error && <p className="admin-login-error">{error}</p>}
            <button type="submit" disabled={loading} className="admin-login-btn">
              {loading ? 'Sending...' : 'Send login code'}
            </button>
          </form>
        ) : (
          <form onSubmit={handleVerifyCode} className="admin-login-form">
            <p className="admin-login-hint">
              We sent a 6-digit code to <strong>{email}</strong>
            </p>
            <label className="admin-login-label">Enter code</label>
            <input
              type="text"
              required
              maxLength={6}
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
              placeholder="123456"
              className="admin-login-input admin-login-otp"
              autoFocus
            />
            {error && <p className="admin-login-error">{error}</p>}
            <button type="submit" disabled={loading} className="admin-login-btn">
              {loading ? 'Verifying...' : 'Verify & log in'}
            </button>
            <button
              type="button"
              className="admin-login-back"
              onClick={() => { setStep('email'); setCode(''); setError(''); }}
            >
              ← Use a different email
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { supabase } from '../supabaseClient';
// import './AdminLogin.css';

// export default function AdminLogin() {
//   const [step, setStep] = useState('email'); // 'email' | 'otp'
//   const [email, setEmail] = useState('');
//   const [code, setCode] = useState('');
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleSendCode = async (e) => {
//     e.preventDefault();
//     setError('');
//     setLoading(true);

//     const { error } = await supabase.auth.signInWithOtp({
//       email,
//       options: { shouldCreateUser: false }, // only allow existing/allow-listed emails
//     });

//     setLoading(false);

//     if (error) {
//       setError(error.message);
//       return;
//     }
//     setStep('otp');
//   };

//   const handleVerifyCode = async (e) => {
//     e.preventDefault();
//     setError('');
//     setLoading(true);

//     const { error } = await supabase.auth.verifyOtp({
//       email,
//       token: code,
//       type: 'email',
//     });

//     setLoading(false);

//     if (error) {
//       setError('Invalid or expired code. Please try again.');
//       return;
//     }
//     navigate('/admin');
//   };

//   return (
//     <div className="admin-login-page">
//       <div className="admin-login-card">
//         <h1 className="admin-login-title">2gs Like Gucci</h1>
//         <p className="admin-login-sub">Admin Dashboard</p>

//         {step === 'email' ? (
//           <form onSubmit={handleSendCode} className="admin-login-form">
//             <label className="admin-login-label">Email address</label>
//             <input
//               type="email"
//               required
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               placeholder="you@example.com"
//               className="admin-login-input"
//             />
//             {error && <p className="admin-login-error">{error}</p>}
//             <button type="submit" disabled={loading} className="admin-login-btn">
//               {loading ? 'Sending...' : 'Send login code'}
//             </button>
//           </form>
//         ) : (
//           <form onSubmit={handleVerifyCode} className="admin-login-form">
//             <p className="admin-login-hint">
//               We sent a 6-digit code to <strong>{email}</strong>
//             </p>
//             <label className="admin-login-label">Enter code</label>
//             <input
//               type="text"
//               required
//               maxLength={6}
//               value={code}
//               onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
//               placeholder="123456"
//               className="admin-login-input admin-login-otp"
//               autoFocus
//             />
//             {error && <p className="admin-login-error">{error}</p>}
//             <button type="submit" disabled={loading} className="admin-login-btn">
//               {loading ? 'Verifying...' : 'Verify & log in'}
//             </button>
//             <button
//               type="button"
//               className="admin-login-back"
//               onClick={() => { setStep('email'); setCode(''); setError(''); }}
//             >
//               ← Use a different email
//             </button>
//           </form>
//         )}
//       </div>
//     </div>
//   );
// }
